module.exports = __webpack_public_path__ + "images/background_morning.jpg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/background_morning.jpg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/background_morning.jpg
// module chunks = site__mhf